import React from 'react';
import './Contact.css';

function Contact() {
  return (
    <section id="contact" className="contact">
      <h2 className="section-title">Contact</h2>
      <div className="contact-content">
          <div className="contact-info">
            <p className="contact-text">
              Ready to improve your AI models? I'm available for flexible task-based work with 
              consistent daily engagement. Let's build better AI together.
            </p>
          <div className="contact-details">
            <div className="contact-item">
              <strong>Location:</strong> Jackson, TN 38305
            </div>
            <div className="contact-item">
              <strong>Email:</strong> jlassiter5@gmail.com
            </div>
            <div className="contact-item">
              <strong>Status:</strong> Available for AI Training Projects
            </div>
          </div>
          <div className="contact-button-container">
            <a href="mailto:jlassiter5@gmail.com" className="contact-button">
              Send Email
            </a>
          </div>
        </div>
        <div className="contact-cta">
          <p className="cta-text">Let's build better AI together.</p>
        </div>
      </div>
    </section>
  );
}

export default Contact;

